var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 59.5",
    style: {
      enableBackground: "new 0 0 141.7 59.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Drop_x0020_Shadow{fill:none;}\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\n\t.Dusk{fill:#FFFFFF;}\n\t.Foliage_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#51AEE2;}\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.3686;stroke-miterlimit:10;}\n\t.st1{fill:#FEFEFE;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.4914;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -350.0788,
    y1: -267.874,
    x2: -349.3717,
    y2: -267.1669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    style: {
      stopColor: "#E2E2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5D4D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5323,
    style: {
      stopColor: "#C0BFC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#A4A2A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B6E6E"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,40.1l24.2-21.8c0,0,2.9-2.8,2.5-7.1c-0.4-4.3-4.9-5.3-4.9-5.3L13.8,0.4C11.3-0.5,2.5,1.7,2.1,11.2 c-0.4,10.5,0,26.1,0,26.1s-0.2,4.5,4.2,5.3S13.7,40.1,13.7,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,55.8L42,34c0,0,2.9-2.8,2.5-7.1s-4.9-5.3-4.9-5.3L18,16.1c-2.5-0.9-11.4,1.2-11.7,10.8 C5.9,37.4,6.2,53,6.2,53s-0.2,4.5,4.2,5.3C14.9,59.1,17.8,55.8,17.8,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.1,13.6v4.9h-3.9v-4.8c0,0,0.2-0.2,0.2-0.2H140.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,38H95v-4.8H79.8c-0.6,0-1.9-1.3-1.9-1.9v-3h11c0.6,0,2-0.6,2.6-1c6.3-3.7,3.9-13.2-3.5-13.7 c-2.9-0.2-7.2-0.2-10.1,0c-3.4,0.2-6.8,2.6-7.2,6.2c-0.4,3.8,0.3,8.3,0,12.2C70.6,34.4,74.1,38,76.5,38z M77.8,20.3 c0-0.7,1.2-1.7,1.9-1.8c1.1-0.2,4.5-0.1,5.8,0c2.2,0.2,3,3.1,1.2,4.4c-0.2,0.2-0.9,0.5-1.1,0.5h-7.7V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.1,38v-4.8h-10.3c-0.6,0-1.9-1.3-1.9-1.9V18.5h7.7v-4.8c0,0-0.2-0.2-0.2-0.2h-7.5V8.7h-7.3v23.4 c0,2.3,3.7,5.9,6,5.9H139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,20.1c-0.3,3.7,0.2,7.8,0,11.5c-0.1,2.5,3.5,6.4,6,6.4h13.6v-4.8H57.9c-1.2,0-2-1.5-2.1-2.5 c-0.3-3.2,0.2-6.8,0-10c-0.1-0.8,1.2-2.2,1.9-2.2h10.3v-4.9H55.3C52,13.6,48.7,16.9,48.5,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.8,38V20.3c0-0.6,1.3-1.8,1.8-1.8h10.4v-4.8c0,0-0.2-0.2-0.2-0.2h-12.6c-3.6,0-7.1,3.9-6.9,7.5l0,17 H104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.7,47.1c-1-1-2.6-1-3.3,0.3c-1.2,2.3,1.3,4.7,3.3,2.8c0.1,1.4-0.5,2.1-1.9,1.9c-0.3,0-1.7-1-1.5-0.2 c0.3,1.2,3.8,1.2,4.1-0.6v-4.9C127.8,46.3,127.6,46.5,127.7,47.1z M125.8,50.2c-1.5-0.5-1.3-3,0.3-3.2 C128.3,46.7,128.2,50.9,125.8,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.4,44.9c-0.8-0.1-1.9,0.1-2.8,0v6h2.4c0.1,0,0.6-0.2,0.7-0.2C122.4,49.7,122,45.3,119.4,44.9z M120.6,49 c-0.2,0.5-1,1.2-1.5,1.2h-1.7v-4.6h1.9c0,0,0.7,0.4,0.8,0.4C120.8,46.6,120.9,48.1,120.6,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.1,44.7h-0.7v2.5c-1.7-2-4.2-0.2-3.5,2.2c0.5,1.6,2.4,2,3.5,0.8c0.1,0.5,0.4,0.8,0.9,0.7 c0.2-0.4-0.2-0.8-0.2-0.9V44.7z M105.8,50.2c-1.6-0.3-1.5-2.9,0-3.2C107.9,46.6,108.1,50.7,105.8,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.6,45.3c0.5,0.1,0.8,0.6,1-0.3c-1.6-0.9-2.7-0.5-3.1,1.3C90.5,46.9,90.8,47,90,47v0.6c0.1,0,0.6,0,0.6,0 c0.1,0.1,0,2.7,0,3.1c0,0.2,0.7,0.2,0.8,0.2v-3.3h1.4v3.1c0,0.2,0.7,0.2,0.8,0.2V47h-2.2C91.3,46,91.4,45.2,92.6,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.4,49.3c-0.5-0.2-0.4,0.2-0.7,0.5c-2,1.6-4.3-1.3-2.9-3.3c0.6-1,2-1.1,2.9-0.4c0.3,0.2,0.3,0.8,0.8,0.3 c0.3-0.3,0.1-0.5-0.2-0.8c-0.7-0.7-1.6-0.8-2.5-0.6c-1.4,0.2-2.3,1.9-2.2,3.3c0.3,2.2,2.9,3.6,4.7,2C76.6,49.9,77,49.4,76.4,49.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.2,50.2c0-0.1-0.2-0.1-0.2-0.1c-0.2-0.4,0-1.8-0.1-2.4c-0.2-1.2-1.2-1.5-2.3-1.4c-0.4,0-1.7,0.4-1,0.9 c1.2-0.5,2.7-0.7,2.5,1.1c-4.4-1.4-3.7,4.3,0.1,1.9c0,0.6,0.4,0.6,0.9,0.6C103.2,50.7,103.2,50.4,103.2,50.2z M101.5,50.2 c-1.7,0.7-2.4-1.3-0.8-1.5c0.3,0,1.2,0,1.4,0.2C102.4,49.3,101.9,50,101.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.5,46.4c-2.3,0-3,2.9-1.3,4.1c0.8,0.6,2.6,0.5,3-0.4c0.6-1.1-1.1,0.1-1.3,0.1c-1,0.2-1.9-0.3-1.8-1.4h3.5 C81.9,47.4,81,46.4,79.5,46.4z M78.1,48.4c0.1-2,2.9-2,2.9,0H78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.7,46.4c-2.2,0.4-2.1,4.1,0.1,4.4C114.5,51.4,114.3,45.7,110.7,46.4z M112,50.1c-2.2,1.2-3-2.8-0.8-3.1 C112.7,46.8,113.3,49.3,112,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.6,46.4c-0.5,0-1.8,0.4-1.2,1c1.1-0.5,2.6-0.8,2.6,0.9c0,0.3-0.5,0-0.8,0c-0.8-0.1-2.1,0.1-2.3,1.1 c-0.3,1.9,2.2,2,3.2,0.9c-0.1,0.6,0.3,0.8,0.8,0.7c0.1-0.5-0.2-0.7-0.2-1.1C137.6,48.1,138.4,46.1,135.6,46.4z M136.6,50.1 c-1.7,0.9-2.6-1.2-1-1.5c0.3-0.1,1.2,0,1.4,0.1C137.4,49.1,137,49.9,136.6,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.5,50.2c-2-0.2-1.5-3.9,0.6-3.1c0.5,0.2,0.4,0.4,0.6,0.5c0.1,0.1,1.3-0.2,0.3-0.9 c-1.8-1.4-4.3,0.6-3.3,2.9c0.5,1.3,2.4,1.7,3.4,0.8c0.1-0.1,0.6-0.5,0.3-0.7C97.8,49.3,97.5,50.3,96.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.6,49.9c-0.1-0.4,0-2.2,0-2.8c0,0,0.9,0.1,0.9-0.1l0-0.6c-0.2,0-0.9,0-0.9,0c0-0.1,0-1.2,0-1.4h-0.8 c0,0.2,0.1,1.4,0,1.4c-0.1,0.1-0.5-0.1-0.6,0.3c-0.1,0.6,0.5,0.3,0.6,0.4c0.2,0.2-0.3,2.9,0.2,3.5c0.4,0.5,2.3,0.4,1.8-0.5 C87.6,50,86.7,50.4,86.6,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.5,49.9c-0.1-0.1-0.2-2.7-0.1-2.8c0.1-0.1,1.6,0.2,1-0.6c-0.2-0.2-0.9,0-1-0.1c0-0.1,0-1.2,0-1.4h-0.7 c0,0.2,0.1,1.4,0,1.4c-0.2,0.2-0.7-0.4-0.6,0.6c0,0.2,0.5,0,0.6,0.1c0.1,0.1,0,2.8,0,3.2c0,0.7,2.5,0.8,1.9-0.3 C133.5,50,132.7,50.4,132.5,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8,49.8l0-4.9c0-0.4-0.5-0.3-0.8-0.3v5.6c0,0.8,1.8,0.8,1.9,0.5C141,49.8,140,50.4,139.8,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.9,46.4c-0.8-0.2-1.1,0.4-1.6,0.8l0-0.8l-0.7,0v4.5h0.7v-2.6c0-0.1,0.4-0.7,0.6-0.8c0.3-0.2,1-0.3,1.1-0.3 C85,47,84.9,46.5,84.9,46.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.4,
    y: 46.4,
    className: "st1",
    width: 0.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.4,46.6c-0.1,0.3-0.1,3.4,0,3.9c0.1,0.6,0.3,0.4,0.8,0.4v-4.5C122.9,46.4,122.5,46.3,122.4,46.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.6,
    y: 46.4,
    className: "st1",
    width: 0.7,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.4,
    y: 44.6,
    className: "st1",
    width: 0.8,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.2,45.7v-1.1C122,44.3,122,46,123.2,45.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.6,
    y: 44.6,
    className: "st1",
    width: 0.7,
    height: 1.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,16.1c-2.5-0.9-11.4,1.2-11.7,10.8c-0.2,4.8-0.2,10.7-0.2,15.7c0.1,0,0.2,0,0.3,0.1 c4.5,0.8,7.3-2.5,7.3-2.5l21.7-19.5L18,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.4,9.8v6.4H19c-1.3,0-2.9,1.5-3,2.8c0.3,4.3-0.4,9.1,0,13.4c0.1,1.6,1.3,2.9,2.9,3.1 c1.2,0.2,6.7,0.2,7.7-0.1c1-0.3,2.2-1.7,2.2-2.7V29h-6.5v-6.4h16v10.8c0,4.6-5.1,8.2-9.4,8.4c-3.9,0.2-9.3,0.2-13.2,0 c-4.7-0.3-9-3.8-9.4-8.6c-0.3-4.9,0.2-10.2,0-15.2c0.7-4.5,4.7-8.1,9.2-8.2L38.4,9.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcert);
export default __webpack_public_path__ + "static/media/gcert.e8efb0586ad595cc1144222bd936d334.svg";
export { ForwardRef as ReactComponent };